/**
 * True when "today" (local midnight) falls on or before `daysBefore` days
 * prior to `dateInput`. Returns true (unrestricted) when dateInput is
 * missing/invalid — callers combine this with their own required checks.
 *
 * e.g. isWithinDaysBeforeDate('10/1/2026', 1) is true through 9/30/2026,
 * and false starting 10/1/2026.
 *
 * @param {string|Date} dateInput - The reference date.
 * @param {number} [daysBefore=0] - Days before dateInput the cutoff falls on.
 * @returns {boolean}
 */
export const isWithinDaysBeforeDate = (dateInput, daysBefore = 0) => {
  if (!dateInput) return true;
  const target = new Date(dateInput);
  if (Number.isNaN(target.getTime())) return true;

  const cutoff = new Date(
    target.getFullYear(),
    target.getMonth(),
    target.getDate() - daysBefore
  );
  const today = new Date();
  const todayAtMidnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  return todayAtMidnight <= cutoff;
};
